
export default {
  namespaced: true,

  state: () => ({
    items: [],
  }),

  mutations: {
    update(state, items) {
      state.items = items
    },
  }
}
